import React from "react";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import UnauthMenu from "./UnauthMenu";
import AuthMenu from "./Auth/AuthMenu";

// component
const User = () => {
    const { currentUser } = useSiteHeader();
    const isAnonymous = currentUser?.isAnonymous ?? true;
    return isAnonymous ? <UnauthMenu /> : <AuthMenu />;
};

export default User;
